(function () {
  /**
   * Open Back In Stock modal
   */
  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-action="open-modal"]');

    if (!openButton) return;

    event.preventDefault();

    const modalId = openButton.getAttribute('aria-controls');
    const modal = document.getElementById(modalId);
    const pageOverlay = document.querySelector('.PageOverlay');

    if (!modal) return;

    modal.setAttribute('aria-hidden', 'false');
    pageOverlay?.classList.add('is-visible');
  });

  /**
   * Close Back In Stock modal
   */
  document.addEventListener('click', function (event) {
    const closeButton = event.target.closest('[data-action="close-modal"]');

    if (!closeButton) return;

    event.preventDefault();

    const modal = closeButton.closest('.Modal');
    const pageOverlay = document.querySelector('.PageOverlay');

    if (!modal) return;

    modal.setAttribute('aria-hidden', 'true');
    pageOverlay?.classList.remove('is-visible');
  });

  /**
   * Submit Back In Stock form to Klaviyo
   */
  document.addEventListener('submit', function (event) {
    const form = event.target.closest('.BIS-form');

    if (!form) return;

    event.preventDefault();

    const emailInput = form.querySelector('[name="klaviyo-email-bis"]');
    const variantInput = form.querySelector('[name="selected_variant_id"]');
    const productInput = form.querySelector('[name="selected_product_id"]');
    const submitButton = form.querySelector('.Form__Submit');
    const successMessage = form.querySelector('.BIS-success');
    const errorMessage = form.querySelector('.BIS-error');

    if (!emailInput || !variantInput || !productInput || !submitButton) return;

    const email = emailInput.value;
    const variantId = variantInput.value;
    const productId = productInput.value;

    submitButton.disabled = true;
    submitButton.classList.add('is-loading');

    if (successMessage) successMessage.style.display = 'none';
    if (errorMessage) errorMessage.style.display = 'none';

    fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
      method: 'POST',
      headers: {
        accept: 'application/json, text/plain, */*',
        'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: new URLSearchParams({
        a: 'VpcFJc',
        email: email,
        platform: 'shopify',
        variant: variantId,
        product: productId,
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Klaviyo Back In Stock request failed');
        }

        return response.json();
      })
      .then(function () {
        if (successMessage) successMessage.style.display = 'block';
        if (errorMessage) errorMessage.style.display = 'none';

        emailInput.value = '';
      })
      .catch(function (error) {
        console.error('Klaviyo BIS error:', error);

        if (successMessage) successMessage.style.display = 'none';
        if (errorMessage) errorMessage.style.display = 'block';

        submitButton.disabled = false;
      })
      .finally(function () {
        submitButton.classList.remove('is-loading');
      });
  });

  /**
   * Product card variant switch
   */
  document.addEventListener('change', function (event) {
    const input = event.target.closest('.product-form__variant');

    if (!input) return;

    const productCard = input.closest('.product-card');

    if (!productCard) return;

    const addToCartButton = productCard.querySelector('.ProductForm__AddToCart');
    const notifyButton = productCard.querySelector('.ProductForm__BIS');

    if (!addToCartButton || !notifyButton) return;

    const isUnavailable = input.classList.contains('product-form__variant-unavailable');
    const isPreorder = input.classList.contains('product-form__variant-preorder');

    addToCartButton.classList.remove('Button--preorder', 'Button--add-to-cart');

    const buttonSpans = addToCartButton.querySelectorAll('span');
    const addToCartText = buttonSpans[0];
    const preorderText = buttonSpans[1];

    if (isUnavailable) {
      addToCartButton.style.display = 'none';
      notifyButton.style.display = 'block';
      return;
    }

    if (isPreorder) {
      addToCartButton.style.display = 'block';
      notifyButton.style.display = 'none';
      addToCartButton.classList.add('Button--preorder');

      if (addToCartText) addToCartText.style.display = 'none';
      if (preorderText) preorderText.style.display = 'inline';

      return;
    }

    addToCartButton.style.display = 'block';
    notifyButton.style.display = 'none';
    addToCartButton.classList.add('Button--add-to-cart');

    if (addToCartText) addToCartText.style.display = 'inline';
    if (preorderText) preorderText.style.display = 'none';
  });
})();